/**
 * Fotos im Tagebuch: Grenzen, die App und Server gleich ziehen.
 *
 * Verkleinert wird **im Browser**, bevor irgendetwas das Gerät verlässt: Ein
 * Telefonfoto hat 4–8 MB, und das Volume des Servers wäre nach ein paar Monaten
 * voll (PLANUNG.md, Offene Punkte). Das Neukodieren als JPEG wirft nebenbei die
 * EXIF-Daten weg — darunter den Aufnahmeort, den niemand im Tagebuch braucht.
 *
 * Der Server prüft dieselbe Obergrenze noch einmal. Eine Grenze, die nur der
 * Client zieht, ist eine Empfehlung.
 */

/** Längste Kante nach dem Verkleinern. Reicht für Vollbild auf jedem Telefon. */
export const PHOTO_MAX_EDGE = 1600;

/** Obergrenze je Foto, vom Server erzwungen. */
export const PHOTO_MAX_BYTES = 2 * 1024 * 1024;

/** Das eine Format, das der Server annimmt — die App kodiert ohnehin neu. */
export const PHOTO_CONTENT_TYPE = 'image/jpeg';

/** Zielgröße bei gleichem Seitenverhältnis; kleinere Bilder bleiben, wie sie sind. */
export function fitWithin(
  width: number,
  height: number,
  maxEdge: number = PHOTO_MAX_EDGE,
): { width: number; height: number } {
  const longest = Math.max(width, height);
  if (longest <= maxEdge || longest <= 0) return { width, height };
  const factor = maxEdge / longest;
  return {
    width: Math.max(1, Math.round(width * factor)),
    height: Math.max(1, Math.round(height * factor)),
  };
}

/**
 * Beginnt der Inhalt wie ein JPEG? Der `Content-Type` der Anfrage ist eine
 * Behauptung des Clients; die ersten drei Bytes sind es nicht.
 */
export function looksLikeJpeg(bytes: Uint8Array): boolean {
  return bytes.length >= 3 && bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff;
}
